/// ///////////////////////////////////////////////////////////////////////////////
// Copyright (C) 2026 CONQUER INNOVATIONS SP. Z O.O. Global B.V. and its affiliate(s).
// All rights reserved.
//
// This software and other materials contain proprietary information
// controlled by CONQUER INNOVATIONS SP. Z O.O. and are protected by applicable copyright legislation.
// Any use and utilization of this software and other materials and
// disclosure to any third parties is conditional upon having a separate
// agreement with CONQUER INNOVATIONS SP. Z O.O. for the access, use, utilization or disclosure of this
// software. In the absence of such agreement, the use of the software is not
// allowed.
// The creator, author and originator of the code in the current file: Michał Pawłowski
//////////////////////////////////////////////////////////////////////////////////

import axios from "axios";
import { defineStore } from "pinia";
import { useLazyLoaderModule } from "@/state/pinia/lazyloaderManagerModule";
import { requiredHeaders } from "@/helpers/authservice/requiredHeaders";
import { apiRequestsHelper } from "@/state/pinia/apiRequestHelper";
import Swal from "sweetalert2";

export const useCommonImportModule = defineStore("commonImportModule", {
    state: () => ({
        lazyLoaderModule: useLazyLoaderModule(),
        import_endpoint_base: "/api/import",
    }),

    actions: {
        /**
         * Wysyła sparsowane dane do backendu.
         * @param {Object} payload { importType: string, records: Array, meta: Object }
         */
        async httpSubmitGenericImport(payload) {
            const { importType, records, meta } = payload;
            const endpoint = `${this.import_endpoint_base}/${importType}`;

            this.lazyLoaderModule.setDisplayLazyLoader(true);
            this.lazyLoaderModule.setProgressBarMessage("Wysyłanie danych do serwera...");

            return axios({
                method: "post",
                url: endpoint,
                headers: requiredHeaders(),
                data: {
                    records: records,
                    meta: meta || {}
                }
            })
                .then((response) => {
                    // Obsługa sukcesu
                    const result = response.data.payload; // GenericImportResponse

                    let message = `Przesłano: ${result.receivedCount}, Zaakceptowano: ${result.acceptedCount}`;
                    if (result.rejectedCount > 0) {
                        message += `<br><span class="text-danger">Odrzucono: ${result.rejectedCount}</span>`;
                    }

                    if (result.errors && result.errors.length > 0) {
                        // Swal.fire({
                        //     icon: 'warning',
                        //     title: 'Import zakończony z błędami',
                        //     html: message + '<hr>' + result.errors.join('<br>'),
                        // });
                        apiRequestsHelper.fireExceptionModal('Import zakończony z błędami\n' + message,result.errors,'error',response)
                    } else {
                        Swal.fire({
                            icon: 'success',
                            title: 'Import zakończony',
                            html: message,
                        });
                    }

                    return response;
                })
                .catch((error) => {
                    return apiRequestsHelper.catchResponseError(error, "httpSubmitGenericImport");
                })
                .finally(() => {
                    this.lazyLoaderModule.setDisplayLazyLoader(false);
                });
        }
    }
});